module.exports = __webpack_public_path__ + "static/media/logo-white-bg-none.d67a481c.svg";